module.exports = __webpack_public_path__ + "static/img/evolucao-sentimento-area.ea6dbc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evolucao-sentimento-area.png
// module id = CgRw
// module chunks = 1